import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import Eyebrow from "Root/profile/components/common/Eyebrow";
import RegFont from "Root/profile/components/common/RegFont";
import toastService from "Root/profile/toastService";
import cx from "classnames";
import styles from "./styles.module.scss";
const ProductCheckbox = (props) => {
    const { value, setValue, autoNext, goNext } = props;
    const [touched, setTouched] = useState(false);
    const dis = (e) => {
        props.setFlag(!props.deselectOtherFlag);
        setValue((prevState) => prevState.concat(value));
        setTouched(true);
    };
    const removeElement = () => {
        setValue((prevState) => [...prevState].filter((elem) => elem !== value));
        setTouched(true);
    };
    const addElement = () => {
        setValue((prevState) => prevState.concat(value));
        setTouched(true);
    };
    useEffect(() => {
        if (autoNext && value && value.length && touched) {
            goNext();
            setTouched(false);
        }
    }, [touched, value]);
    const clickHandler = (e) => {
        if (props.deselectOtherFlag) {
            dis(e.currentTarget.value);
            return;
        }
        if (props.deselectOther) {
            dis(e.currentTarget.value);
            return;
        }
        const deselectValues = props.deselect;
        if (deselectValues.length > 0) {
            const selectedItem = props.answers.find((item) => deselectValues.includes(item));
            setValue((prevState) => [...[...prevState].filter((elem) => elem !== selectedItem), value]);
            return;
        }
        if (props.answers.includes)
            if (props.answers.includes(value)) {
                removeElement();
            }
            else if (props.stopper) {
                if (props.stopper !== props.answers.length) {
                    addElement();
                }
                else {
                    toastService.errorMessage("Maximum number of selected options");
                }
            }
            else {
                addElement();
            }
        e.currentTarget.checked = !e.currentTarget.checked;
    };
    const textArr = props.text.split("|");
    const title = textArr.length > 0 && textArr[0];
    const subtitle = textArr.length > 1 && textArr[1];
    return (_jsxs("label", { className: cx(styles.product_checkbox, { [styles.tall]: props.variant === "tall" }), htmlFor: value, style: props.style, children: [_jsx("input", { id: value, type: "checkbox", value: value, onClick: clickHandler, onChange: () => null, name: value, checked: props.answers.includes(value) }), _jsxs("div", { className: styles.image, children: [_jsx("div", { className: [styles.checkmark, props.answers.includes(value) ? styles.checkmark_selected : ""].join(" "), children: props.answers.includes(value) && (_jsx("svg", { width: "14", height: "11", viewBox: "0 0 14 11", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M1.25 5.5L4.75 9L12.75 1", stroke: "#fff", strokeWidth: "1.5" }) })) }), _jsx("img", { src: props.imgSrc, alt: props.text })] }), _jsx(Eyebrow, { opacity: 1, children: title }), subtitle && _jsx(RegFont, { children: subtitle })] }));
};
export default ProductCheckbox;
